export default "__VITE_ASSET__CA6fkxbN__"